import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M11.9952 4.00001C7.83644 3.99432 4.36689 7.17599 4.01323 11.3197C3.65958 15.4634 6.53979 19.187 10.6394 19.8862C14.739 20.5853 18.6905 18.0267 19.7302 14H17.6492C16.632 16.8771 13.6172 18.5324 10.6437 17.8465C7.67013 17.1605 5.68512 14.3519 6.03103 11.3199C6.37694 8.28792 8.94357 5.99856 11.9952 6.00001C13.5848 6.00234 15.1066 6.64379 16.2182 7.78002L13.0002 11H20.0002V4.00001L17.6492 6.35002C16.1529 4.84464 14.1177 3.99873 11.9952 4.00001Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Refresh"
);
